import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers/';
import * as filterReducers from '../reducers/filter.reducers';

export const getFilterFeatureState = createSelector(
  fromFeature.getFilterState,
  (state: fromFeature.FiltersReducersState) => state.data
);

export const getAllDiningFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.dining
);

export const getDiningCuisineFilters = createSelector(getAllDiningFilters, (state) => state.cuisine);

export const getDiningTagFilters = createSelector(getAllDiningFilters, (state) => state.tag);

export const getDiningEsgTagFilters = createSelector(getAllDiningFilters, (state) => state.esg_tag);

export const getDiningMemberBenefitsFilters = createSelector(getAllDiningFilters, (state) => state.memberBenefits);

export const getAllMemberEventFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.memberEvents
);

export const getMemberEventCategoryFilter = createSelector(getAllMemberEventFilters, (state) => state.tag);

export const getAllEntertainmentFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.entertainment
);

export const getEntertainmentCategoryFilter = createSelector(getAllEntertainmentFilters, (state) => state.category);

export const getAllMemberBenefitFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.memberBenefits
);

export const getMemberBenefitTagFilters = createSelector(getAllMemberBenefitFilters, (state) => state.tag);

export const getAllArticleFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.articles
);

export const getArticleCategoryFilter = createSelector(getAllArticleFilters, (state) => state.category);

export const getAllInspirationFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.inspiration
);

export const getInspirationCategoryFilter = createSelector(getAllInspirationFilters, (state) => state.category);

export const getInspirationDestinationFilter = createSelector(getAllInspirationFilters, (state) => state.destination);

export const getAllHotelFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.hotels
);

export const getHotelAmenitiesFilter = createSelector(getAllHotelFilters, (state) => state.amenity);

export const getHotelStarRatingsFilter = createSelector(getAllHotelFilters, (state) => state.property_class);

export const getAllFlightFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.flights
);

export const getFlightAirlineFilter = createSelector(getAllFlightFilters, (state) => state.airline);

export const getFlightDepartureFilter = createSelector(getAllFlightFilters, (state) => state.departure_time);

export const getAllCarFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.cars
);

export const getCarCapacityFilter = createSelector(getAllCarFilters, (state) => state.pax_capacity);

export const getCarSupplierFilter = createSelector(getAllCarFilters, (state) => state.supplier);

export const getCarTypeFilter = createSelector(getAllCarFilters, (state) => state.car_type);

export const getInstalmentPaymentAvailableFilter = createSelector(
  getAllCarFilters,
  (state) => state.instalment_payment_available
);

export const getAllPrimaryInterestFilters = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState) => state.primaryInterest
);

export const getPrimaryInterestCategoryFilters = createSelector(
  getAllPrimaryInterestFilters,
  (state) => state.category
);

export const getFilterSelectedData = createSelector(
  getFilterFeatureState,
  (state: filterReducers.FilterState, props: { module: string; filterName: string; filterValue: any }) => {
    const filterData: Array<any> = state[props.module]?.[props.filterName];
    if (filterData && filterData.length > 0 && props.filterValue !== null && !Array.isArray(props.filterValue)) {
      const filterObject = filterData.find((data) => data.id.toString() === props.filterValue.toString());
      return filterObject?.name || filterObject?.title;
    } else {
      return '';
    }
  }
);
